import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	RabatSk: null as string | null,
	RabatSkText: null as string | null,
	SlevaBezpodporySzb: null as number | null,
	SlevaEconomySzb: null as number | null,
	SlevaSzb: null as number | null,
	SlevamatSk: null as number | null,
	VyrobekndOzn: null as string | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SlevamatSk: [],
		VyrobekndOzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.SLEVAMAT_RABAT_SK_SELECT_MAPPER](state, { data }) {
			state.edit.RabatSk = data.value;
			state.edit.RabatSkText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
